import React from 'react'
import { useAuth } from '../contexts/AuthContext'
import {
  StyledNav,
  NavList,
  NavItem,
  StyledNavLink,
  NavIcon,
  NavLabel,
} from './Navigation.styles'

const Navigation: React.FC = () => {
  const { isAdmin } = useAuth()
  
  const navItems = [
    { path: '/device-management', label: 'Device Management', icon: '⚙️' },
    { path: '/parts', label: 'Parts Management', icon: '🔧' },
    { path: '/inventory', label: 'Inventory', icon: '📦' },
    { path: '/bom', label: 'BOM Management', icon: '📋' },
    { path: '/work-orders', label: 'Work Orders', icon: '🔨' },
    { path: '/reporting', label: 'Reporting', icon: '📊' }
  ]

  // Add admin-only features
  if (isAdmin()) {
    navItems.push(
      { path: '/models', label: 'Model Management', icon: '🏷️' },
      { path: '/model-categories', label: 'Model Categories', icon: '🏭' },
      { path: '/manufacturers', label: 'Manufacturers', icon: '🏢' },
      { path: '/audit-log', label: 'Audit Log', icon: '📝' }
    )
  }

  return (
    <StyledNav>
      <NavList>
        {navItems.map((item) => (
          <NavItem key={item.path}>
            <StyledNavLink to={item.path}>
              <NavIcon>{item.icon}</NavIcon>
              <NavLabel>{item.label}</NavLabel>
            </StyledNavLink>
          </NavItem>
        ))}
      </NavList>
    </StyledNav>
  )
}

export default Navigation